const PROACTIVE_CHAT_OPTIONS = {
  tenant: 'Sharper Image',
  showProfiles: false,
  restAPI: 'https://app.five9.com',
  chatConsole: 'https://app.five9.com/consoles/ChatConsole/index.html',
  notificationType: 'notification',
  useBusinessHours: true,
  showEmailButton: true,
  hideDuringAfterHours: false,
};

const canInitChat = () => {
  const globalObject = typeof window === 'undefined' ? {} : window;
  if (_.isEmpty(globalObject)) {
    return false;
  }
  const chatExists =
    typeof globalObject.Five9SocialWidget !== 'undefined' &&
    typeof globalObject.Five9ProactiveChat !== 'undefined' &&
    _.get(globalObject, 'Five9Modules.SharedProactive', null) &&
    _.get(globalObject, 'Five9Modules.SharedProactive.supportsFeatures', null);
  if (!chatExists) {
    return false;
  }
  const pageDefaults = {
    totalduration: 0,
    numberofvisit: 0,
  };
  const five9SessionStorage = {
    pages: {
      payment: { ...pageDefaults },
      shipping: { ...pageDefaults },
      'shopping-cart': { ...pageDefaults },
      'static-page': { ...pageDefaults },
      product: { ...pageDefaults },
    },
    history: [],
  };
  window.sessionStorage.setItem('five9_proactive_chat_sessiondata', JSON.stringify(five9SessionStorage));
  return true;
};

const loadChat = async () => {
  Five9SocialWidget.addWidget({
    type: 'chat',
    rootUrl: 'https://app.five9.com/consoles/',
    profiles: ['Chat'],
    showProfiles: false,
    tenant: 'Sharper Image',
    restAPI: 'https://app.five9.com',
    chatConsole: 'https://app.five9.com/consoles/ChatConsole/index.html',
    notificationType: 'notification',
    useBusinessHours: true,
    showEmailButton: true,
    hideDuringAfterHours: false,
    logo: chatImage,
    title: ' ',
    theme: chatTheme,
    fields: {
      email: {
        value: chatEmail,
        show: false,
        label: 'Email Address',
      },
      ipaddress: {
        value: null,
        show: false,
        label: 'IPAddress',
        required: false,
      },
    },
  });
};

const proactiveChat = (pageId, profile) => {
  const globalObject = typeof window === 'undefined' ? {} : window;
  if (canInitChat(globalObject)) {
    if (!document.referrer) {
      Object.defineProperty(document, 'referrer', {
        get: () => window.location.href,
        set: function (value) {
          this.referer = value;
        },
      });
    }
    Five9ProactiveChat.init(PROACTIVE_CHAT_OPTIONS);
    if (document.referrer !== window.location.href) {
      document.referer = window.location.href;
    }
    Five9ProactiveChat.startNewPage({
      pageId: pageId,
      profiles: [profile],
    });
  } else {
    chatLoop(() => {
      proactiveChat(pageId, profile);
    });
  }
};

const chatLoop = (callback) => {
  const globalObject = typeof window === 'undefined' ? {} : window;
  setTimeout(() => {
    if (canInitChat(globalObject)) {
      callback();
    } else {
      chatLoop(callback);
    }
  }, 1000);
};

const hideFive9Chat = () => {
  const five9Frame = document.querySelectorAll('.five9-frame')[0];

  if (!!(five9Frame)) {
    five9Frame.remove();
  }
};

window.addEventListener('load', () => {
  if (canInitChat()) {
    loadChat();
  } else {
    chatLoop(loadChat);
  }
});

const addNoibuError = (name, message) => {
  let err = new Error(message ? `${name} - ${message}` : name);
  err.name = name;
  console.error(err.name, err);
  window.NOIBUJS?.addError(err)
};

const openCsChat = () => {
  const five9Button = document.getElementById('five9-maximize-button');
  if (!five9Button) {
    addNoibuError('Five 9', 'Button does not exist, chat may have failed to load');
    return;
  }
  five9Button.click();
};